<template>
  <div>
    <div class="content">
      <LandingNavbar class="border-b-2" />
      <main class="flex flex-col justify-center w-full h-full">
        <slot />
      </main>
      <LandingFooter />
      <LandingCookies />
    </div>
    <div class="resolution-notice bg-red-200 text-xl text-slate-900 font-bold">
      Toto rozlíšenie nie je podporované.
    </div>
    <LandingHelp />
  </div>
</template>

<style lang="scss">
.content {
  @apply container flex flex-col justify-between bg-white gap-2 xl:gap-4 px-2 sm:px-4 md:px-8 lg:px-12 xl:px-16;

  @media only screen and ((max-height: 250px) or (max-width: 250px)) {
    @apply hidden;
  }
}

.resolution-notice {
  @apply hidden;

  @media only screen and ((max-height: 250px) or (max-width: 250px)) {
    @apply flex items-center text-center;
  }
}
</style>
